import { render } from "./EmailLanguageForm.vue?vue&type=template&id=26f9dd85&scoped=true"
import script from "./EmailLanguageForm.vue?vue&type=script&lang=js"
export * from "./EmailLanguageForm.vue?vue&type=script&lang=js"

import "./EmailLanguageForm.vue?vue&type=style&index=0&id=26f9dd85&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26f9dd85"]])

export default __exports__